// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../assets/images/bg/bg-menu.png");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".menu[data-v-123634d6]{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ")}.fade-enter-active[data-v-123634d6],.fade-leave-active[data-v-123634d6]{transition:opacity .2s ease-out}.fade-enter-from[data-v-123634d6],.fade-leave-to[data-v-123634d6]{opacity:0}", ""]);
// Exports
module.exports = exports;
